module.exports = __webpack_public_path__ + "img/coupon_tutorial_totolu04.7a0c7628.png";